// extracted by mini-css-extract-plugin
export var container = "_es-1";
export var cornerButtonContainer = "_es-6";
export var disabled = "_es-2";
export var dragActive = "_es-3";
export var fileContainer = "_es-5";
export var hiddenInput = "_es-4";
export var widthContainer = "_es-0";